import React, { Component } from 'react'
import configs from '../../../configs.json'

class AboutUs extends Component {
    constructor(props) {
        super(props)
        this.state = this.computeColors(props.colored, props.dark)
    }
    computeColors(colored, dark) {
        if (colored && dark) {
            return { colored, dark, backgroundColor: configs.colors.primary, text: configs.colors.light, color: configs.colors.dark }
        }
        if (!colored && !dark) {
            return { colored, dark, color: configs.colors.primary, text: configs.colors.dark, backgroundColor: configs.colors.light }
        }
        if (!colored && dark) {
            return { colored, dark, color: configs.colors.primary, text: configs.colors.light, backgroundColor: configs.colors.dark }
        }
        return { colored, dark, backgroundColor: configs.colors.primary, text: configs.colors.dark, color: configs.colors.light }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.colored !== this.props.colored || prevProps.dark !== this.props.dark) {
            this.setState(this.computeColors(this.props.colored, this.props.dark))
        }
    }
    render(){
        return (
            <div className='container' style={{backgroundColor: this.state.backgroundColor}} id='aboutus'>
                <div className='row section-row'>
                    <h3 style={{color: this.state.color}} >Sobre Nós</h3>
                    <h6 style={{color: this.state.text}} >Venha nos conhecer</h6>
                    <div className='col s12 m8 left-align'>
                        <strong style={{color: this.state.color}}><h5>{ configs.aboutus.title }</h5></strong>
                        <p style={{color: this.state.text}} >{ configs.aboutus.intro }</p>
                        {configs.services.map((s) =>
                            <h6 className='valign-wrapper' key={s.name}>
                                <i className="material-icons" style={{color:this.state.color}}>{s.icon}</i><span className='service-item' style={{color: this.state.text}}>{ s.name }</span><br/>
                            </h6>
                        )}
                        <p style={{color: this.state.text}} >{ configs.aboutus.conclusion }</p>
                    </div>
                    <div className='col s12 m4'>
                        <img className="responsive-img" alt='colorful pills' style={{border: '3px solid' + this.state.color}} src={require("../../../static/imgs/logo.svg")}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default AboutUs